export default function Footer() {
  return (
    <footer className="bg-neutral-100 text-neutral-600 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-neutral-500 ">
          © 2025 Junsung Lee. All rights reserved.
        </p>
      </div>
    </footer>
  )
}